module.exports = __webpack_public_path__ + "img/goodsB1.f73ca354.png";